import * as React from "react";

export default function NotFound(props) {
    return (
        <div className="p-8 md:p-16 mx-auto">
          <h2 className="text-xl text-center text-teal-700 mb-4">404 page not found</h2>
          <p className="text-gray-700 text-center">We are sorry but the page you are looking for does not exist</p>
        </div>
    );
}
